import ListItem from "@/shared/ts/listItem";

class StaticData {
  constructor() {
    this.InflationData = new Array<ListItem>();
    this.InflationData.push(new ListItem("No Increase", "ZeroPercent"));
    this.InflationData.push(
      new ListItem("Linked to Inflation", "LinkedToInflation")
    );
    this.InflationData.push(new ListItem("3%", "ThreePercent"));
    this.InflationData.push(new ListItem("5%", "FivePercent"));

    this.SexData = new Array<ListItem>();
    this.SexData.push(new ListItem("Male", "Male"));
    this.SexData.push(new ListItem("Female", "Female"));

    this.YesNoData = new Array<ListItem>();
    this.YesNoData.push(new ListItem("Yes", "Yes"));
    this.YesNoData.push(new ListItem("No", "No"));

    this.InflationRate = 2.5;
  }

  public InflationData: Array<ListItem>;

  public SexData: Array<ListItem>;

  public YesNoData: Array<ListItem>;

  public InflationRate: number;
}

const staticData = new StaticData();

export { staticData };
